import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import {generateGuid} from "../../util/guid";
import Tooltip from "./Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "./ValidationMessage";
import Revert from "./Revert";

const Datalist = (props) => {
	const hasError = !!props.error;
	const hasLabel = !!props.label;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const defaultItem = props.defaultItem ? props.defaultItem : "Kies een optie";
	const value = props.value ? props.items.filter(i => i.value == props.value)[0] ? props.items.filter(i => i.value == props.value)[0].label : props.value : "";
	const sizeClassName = props.size ? "o-col-" + props.size : (props.small ? "" : "o-col-12");
	const label = hasLabel ? props.label + (props.optional ? " (Optioneel)" : "") : null;
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.error ? <ValidationMessage error={props.error} /> : null;
	const id = generateGuid();

	const revertable = (props.disabled !== true && props.disabled !== 'true') && props.originalValue !== undefined ? (props.originalValue || "") !== (props.value || "") : false;

	const small = props.small;
	const style = props.small ? { margin: "4px", padding: "2px 30px 2px 2px", minHeight: "2em", color: "black", fontWeight: "normal", width: "auto" } : null;

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": true
	});

	const containerClassName = props.small ? null : classnames({
		"c-input": true,
		"c-input--dropdown": true,
		"has-value": true,
		"error": hasError,
		"disabled": props.disabled
	});

	function handleOnChange(e) {
		const item = props.items.find(i => i.label === e.target.value);
		e.target.value = item ? item.value : e.target.value;
		props.onChange(e);
	}

	const select = (
		<div>
			<input type="text"
				list={"items" + props.name}
				name={props.name}
				id={id}
				value={value}
				autoComplete
				onChange={handleOnChange}
				disabled={props.disabled}
				className={inputClassName}
				style={style} />
			{props.hideDataList ||
				<datalist id={"items" + props.name} >
					<option value="">{defaultItem}</option>
					{
						props.items.map((item) => {
							return (
								<option key={item.value.trim()} value={item.label.trim()}>
									{item.label}
								</option>);
						})
					}
				</datalist>
			}
		</div>
	);

	return (small ? select :
		<div className={sizeClassName}>
			<div className={containerClassName}>
				{select}
				{hasLabel ? <label className={labelClassName} htmlFor={id}>{label}</label> : null}
				{info}
				{!revertable || <Revert
					onChange={handleOnChange}
					name={props.name}
					originalValue={props.originalValue}
					className="c-undo_select" />}
			</div>
			{validation}
		</div>);
};

Datalist.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	originalValue: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	error: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	items: PropTypes.array,
	small: PropTypes.bool,
	hideDataList: PropTypes.bool
};

export default Datalist;
